var map = {
	"./accordion/accordion.ts": "./src/patterns/components/accordion/accordion.ts",
	"./alert/alert.ts": "./src/patterns/components/alert/alert.ts",
	"./app-store/app-store.ts": "./src/patterns/components/app-store/app-store.ts",
	"./avatar/avatar.ts": "./src/patterns/components/avatar/avatar.ts",
	"./badge/badge.ts": "./src/patterns/components/badge/badge.ts",
	"./breadcrumbs/breadcrumbs.ts": "./src/patterns/components/breadcrumbs/breadcrumbs.ts",
	"./button/button.ts": "./src/patterns/components/button/button.ts",
	"./calculator-package/calculator-package.ts": "./src/patterns/components/calculator-package/calculator-package.ts",
	"./card/card.ts": "./src/patterns/components/card/card.ts",
	"./carousel/carousel.ts": "./src/patterns/components/carousel/carousel.ts",
	"./component/component.ts": "./src/patterns/components/component/component.ts",
	"./corner-buttons/corner-buttons.ts": "./src/patterns/components/corner-buttons/corner-buttons.ts",
	"./dropdown/dropdown.ts": "./src/patterns/components/dropdown/dropdown.ts",
	"./editor/editor.ts": "./src/patterns/components/editor/editor.ts",
	"./footer/footer.ts": "./src/patterns/components/footer/footer.ts",
	"./forms/check/check.ts": "./src/patterns/components/forms/check/check.ts",
	"./forms/choice-group/choice-group.ts": "./src/patterns/components/forms/choice-group/choice-group.ts",
	"./forms/datepicker/datepicker.ts": "./src/patterns/components/forms/datepicker/datepicker.ts",
	"./forms/filefield/filefield.ts": "./src/patterns/components/forms/filefield/filefield.ts",
	"./forms/radio/radio.ts": "./src/patterns/components/forms/radio/radio.ts",
	"./forms/range/range.ts": "./src/patterns/components/forms/range/range.ts",
	"./forms/select/select.ts": "./src/patterns/components/forms/select/select.ts",
	"./forms/textarea/textarea.ts": "./src/patterns/components/forms/textarea/textarea.ts",
	"./forms/textfield/textfield.ts": "./src/patterns/components/forms/textfield/textfield.ts",
	"./forms/toggle/toggle.ts": "./src/patterns/components/forms/toggle/toggle.ts",
	"./grid/grid.ts": "./src/patterns/components/grid/grid.ts",
	"./header-navigation/header-navigation.ts": "./src/patterns/components/header-navigation/header-navigation.ts",
	"./header/header.ts": "./src/patterns/components/header/header.ts",
	"./helpers/helpers.ts": "./src/patterns/components/helpers/helpers.ts",
	"./hero-carousel/hero-carousel.ts": "./src/patterns/components/hero-carousel/hero-carousel.ts",
	"./hero-navigation/hero-navigation.ts": "./src/patterns/components/hero-navigation/hero-navigation.ts",
	"./icon/icon.ts": "./src/patterns/components/icon/icon.ts",
	"./image/image.ts": "./src/patterns/components/image/image.ts",
	"./job/job.ts": "./src/patterns/components/job/job.ts",
	"./languages/languages.ts": "./src/patterns/components/languages/languages.ts",
	"./lightbox/lightbox.ts": "./src/patterns/components/lightbox/lightbox.ts",
	"./logo/logo.ts": "./src/patterns/components/logo/logo.ts",
	"./main/main.ts": "./src/patterns/components/main/main.ts",
	"./map-tag/map-tag.ts": "./src/patterns/components/map-tag/map-tag.ts",
	"./map/map.ts": "./src/patterns/components/map/map.ts",
	"./modal/modal.ts": "./src/patterns/components/modal/modal.ts",
	"./module-handle/module-handle.ts": "./src/patterns/components/module-handle/module-handle.ts",
	"./navigation/navigation.ts": "./src/patterns/components/navigation/navigation.ts",
	"./notifications/cookie-notification/cookie-notification.ts": "./src/patterns/components/notifications/cookie-notification/cookie-notification.ts",
	"./notifications/notification-list/notification-list.ts": "./src/patterns/components/notifications/notification-list/notification-list.ts",
	"./notifications/notification/notification.ts": "./src/patterns/components/notifications/notification/notification.ts",
	"./package/package.ts": "./src/patterns/components/package/package.ts",
	"./pagination/pagination.ts": "./src/patterns/components/pagination/pagination.ts",
	"./reset/reset.ts": "./src/patterns/components/reset/reset.ts",
	"./search-list/search-list.ts": "./src/patterns/components/search-list/search-list.ts",
	"./section/section.ts": "./src/patterns/components/section/section.ts",
	"./share/share.ts": "./src/patterns/components/share/share.ts",
	"./sidenavigation/sidenavigation.ts": "./src/patterns/components/sidenavigation/sidenavigation.ts",
	"./spinner/spinner.ts": "./src/patterns/components/spinner/spinner.ts",
	"./tabs/tabs.ts": "./src/patterns/components/tabs/tabs.ts",
	"./tag-filter/tag-filter.ts": "./src/patterns/components/tag-filter/tag-filter.ts",
	"./tag/tag.ts": "./src/patterns/components/tag/tag.ts",
	"./testimonial/testimonial.ts": "./src/patterns/components/testimonial/testimonial.ts",
	"./title/title.ts": "./src/patterns/components/title/title.ts",
	"./typography/typography.ts": "./src/patterns/components/typography/typography.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/patterns/components sync recursive ^\\.\\/.*(?<%21--example)\\.ts$";